(() => {
  const initStudio = (root) => {
    if (!root || root.dataset.studioV2Ready === "true") return;

    const tabs = Array.from(root.querySelectorAll("[data-flow-tab]"));
    const panels = Array.from(root.querySelectorAll("[data-flow-panel]"));
    const links = Array.from(root.querySelectorAll("[data-flow-link]"));

    if (!tabs.length || !panels.length) return;

    const activate = (key, moveFocus = false) => {
      const nextTab = tabs.find((tab) => tab.dataset.flowTab === key);
      const nextPanel = panels.find((panel) => panel.dataset.flowPanel === key);
      if (!nextTab || !nextPanel) return;

      tabs.forEach((tab) => {
        const selected = tab === nextTab;
        tab.classList.toggle("is-active", selected);
        tab.setAttribute("aria-selected", selected ? "true" : "false");
        tab.tabIndex = selected ? 0 : -1;
      });

      panels.forEach((panel) => {
        panel.hidden = panel !== nextPanel;
      });

      if (moveFocus) nextTab.focus();
    };

    tabs.forEach((tab, index) => {
      tab.addEventListener("click", () => activate(tab.dataset.flowTab));
      tab.addEventListener("keydown", (event) => {
        let nextIndex = index;

        if (event.key === "ArrowRight" || event.key === "ArrowDown") {
          nextIndex = (index + 1) % tabs.length;
        } else if (event.key === "ArrowLeft" || event.key === "ArrowUp") {
          nextIndex = (index - 1 + tabs.length) % tabs.length;
        } else if (event.key === "Home") {
          nextIndex = 0;
        } else if (event.key === "End") {
          nextIndex = tabs.length - 1;
        } else {
          return;
        }

        event.preventDefault();
        activate(tabs[nextIndex].dataset.flowTab, true);
      });
    });

    links.forEach((link) => {
      link.addEventListener("click", () => activate(link.dataset.flowLink));
    });

    root.dataset.studioV2Ready = "true";
  };

  const initAll = (scope = document) => {
    scope.querySelectorAll("[data-eight-studio-v2]").forEach(initStudio);
  };

  initAll();
  document.addEventListener("shopify:section:load", (event) => initAll(event.target));
})();
